import { SiteData } from '../../../interfaces/site-data';

/* istanbul ignore file */
export class DifferencesObject {
    appId: string;
    projectId: string;
    siteId: string;
    objectFieldId: string;
    fieldId: string;
    objectId: string;
    isPathValid = false;
    value: SiteData = {};
    path: string;
}
